import { ViewModelBase } from "@shoothill/core";
import { action, computed, makeObservable, observable, runInAction } from "mobx";

import { MentorsModel } from "./MentorsModel";
import { AppUrls } from "AppUrls";
import { ITab } from "Components/Tabs/Interfaces/ITab";
import { ITabs } from "Components/Tabs/Interfaces/ITabs";
import { APIClient, ICommand, RelayCommand } from "Application";
import toast from "react-hot-toast";
import { GET_GetMentorsCountEndpoint, MentorsCountResponse } from "../Mentor/WeeklyRota/Endpoints/GetMentorCount/GetMentorCountEndpoint";

export class MentorsViewModel extends ViewModelBase<MentorsModel> {
    public apiClient = new APIClient();

    constructor() {
        super(new MentorsModel());
        makeObservable(this, {
            //observable
            pathname: observable,
            //action
            setPathname: action,
            //computed
            tabs: computed,
            showCurrent: computed,
            showPast: computed,
        });
    }

    //#endregion api calls

    //#region properties
    public get showCurrent() {
        return this.pathname.includes(AppUrls.Client.Mentors.Current);
    }
    public get showPast() {
        return this.pathname.includes(AppUrls.Client.Mentors.Past);
    }
    //region actions
    public setPathname = (pathname: string) => {
        this.pathname = pathname;
    };
    public pathname: string = "";

    public get tabs(): ITab[] {
        return [
            {
                path: AppUrls.Client.Mentors.Current,
                name: `Live (${this.model.current})`,
            },
            {
                path: AppUrls.Client.Mentors.Past,
                name: `Past (${this.model.past})`,
            },
        ];
    }

    public navigation: ITabs = {
        tabs: this.tabs,
    };

    public resetApiClientErrorCommand = new RelayCommand(() => {
        this.apiClient.reset();
    });

    public navigateToAddMentorCommand = new RelayCommand(
        () => {
            this.history.push(AppUrls.Client.Mentors.MentorDetail.Root);
        },
        () => this.apiClient.IsBusy === false,
    );

    public onConfirmMentorStatusChangeCommand = new RelayCommand(async () => {
        await this.getMentorCountAsync();
    });

    public getMentorCountAsync = async () => {
        const endpoint = new GET_GetMentorsCountEndpoint();
        await this.apiClient.sendAsync(endpoint);
        if (this.apiClient.IsRequestSuccessful) {
            runInAction(() => {
                const response: MentorsCountResponse = this.apiClient.Response();
                this.model.fromResponse(response);
            });
        }
    };

    //region commands
    public onConfirmDeleteStudentCommand: ICommand = new RelayCommand(async () => {
        await this.getMentorCountAsync();
    });
}
